;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:propstrata-app":true});}catch(e){}}();const CATALOG_LAUNCHER_BEACON_DAYS = 5;
const MILLISECONDS_PER_DAY = 24 * 60 * 60 * 1000;

export function shouldShowCatalogLauncherBeacon({
	accountCreatedAt,
	now = new Date(),
}: {
	accountCreatedAt: string | undefined;
	now?: Date;
}): boolean {
	if (!accountCreatedAt) {
		return false;
	}

	const createdAt = new Date(accountCreatedAt);
	if (Number.isNaN(createdAt.getTime())) {
		return false;
	}

	const elapsedMs = now.getTime() - createdAt.getTime();
	return elapsedMs < CATALOG_LAUNCHER_BEACON_DAYS * MILLISECONDS_PER_DAY;
}
